import Reflux from 'reflux';
import {
  AppActions,
  CourseActions,
  PageLayoutActions,
  PageModuleActions
} from 'actions';
import SteelCompass from 'services/SteelCompass';
import { normalize, Schema, arrayOf } from 'normalizr';

const module = new Schema('pageModules');
const row = new Schema('pageRows');
const page = new Schema('page');

row.define({
  pageModules: arrayOf(module)
});

page.define({
  pageRows: arrayOf(row)
});

const moveElement = (array, from, to) => {
  const defCopy = [...array];
  let dest = to;
  if (from < to) {
    dest = dest - 1;
  }
  if (to >= defCopy.length) {
    let k = to - defCopy.length;
    while (k-- + 1) {
      defCopy.push(undefined);
    }
  }
  defCopy.splice(dest, 0, defCopy.splice(from, 1)[0]);
  return defCopy.filter(item => typeof item !== 'undefined');
};

const PageLayoutStore = Reflux.createStore({
  listenables: [PageLayoutActions],
  data: {
    enabled: false,
    moduleMenuEnabled: false,
    overRow: {},
    selectedPageModuleId: null,
    entities: {
      page: {},
      pageRows: {},
      pageModules: {},
      result: null
    }
  },
  init() {
    this.listenTo(CourseActions.getPageByIdComplete, this.readTocComplete);
    this.listenTo(
      CourseActions.addPageModuleComplete,
      this.addPageModuleComplete
    );
    this.listenTo(
      CourseActions.deleteModuleComplete,
      this.deletePageModuleComplete
    );
    this.listenTo(
      PageModuleActions.changePageModuleMode,
      this.changePageModuleMode
    );
    this.listenTo(
      PageModuleActions.savePageModuleComplete,
      this.savePageModuleComplete
    );
    this.listenTo(PageModuleActions.changePageModule, this.changePageModule);
    this.listenTo(
      PageModuleActions.savePageModuleUserDataComplete,
      this.savePageModuleUserDataComplete
    );
    this.listenTo(CourseActions.answerTaskComplete, this.answerTaskComplete);
    this.listenTo(CourseActions.updateTaskComplete, this.updateTaskComplete);
  },
  getInitialState() {
    return this.data;
  },
  readTocComplete(toc) {
    const data = normalize(toc, page);
    this.data = {
      ...this.data,
      ...data
    };
    this.trigger(this.data);
  },
  addPageModule(type) {
    return SteelCompass.request('page-module', 'create', {
      type,
      newRow: true,
      pageId: this.data.result
    }).then(
      response => {
        CourseActions.addPageModuleComplete(response.pageRows);
      },
      error => {
        console.log(error); // quiziframe => "Undefined module type."
        AppActions.genericError(error);
      }
    );
  },
  savePageModule(id) {
    const module = this.data.entities.pageModules[id];
    const { content, params, sources, caption } = module.data;
    return SteelCompass.request('page-module', 'update', {
      id,
      caption,
      content,
      params,
      sources
    }).then(
      response => {},
      error => {
        AppActions.genericError(error);
      }
    );
  },
  changePageModuleMode(pageModuleId, mode) {
    const { entities } = this.data;
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...entities.pageModules[pageModuleId],
            mode
          }
        }
      }
    };
    this.trigger(this.data);
  },
  changePageModule(moduleData, callback) {
    const { entities } = this.data;
    const { id: pageModuleId } = moduleData;
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...entities.pageModules[pageModuleId],
            ...moduleData
          }
        }
      }
    };
    callback &&
      callback({
        ...entities.pageModules[pageModuleId],
        ...moduleData
      });
    this.trigger(this.data);
  },
  selectPageModule(selectedPageModuleId) {
    this.data = {
      ...this.data,
      selectedPageModuleId
    };
    this.trigger(this.data);
  },
  changePageModuleData(moduleData) {
    const { entities } = this.data;
    const { id: pageModuleId, data, ...rest } = moduleData;
    const module = entities.pageModules[pageModuleId];
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...module,
            ...rest,
            data: {
              ...module.data,
              ...data
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  savePageModuleUserDataComplete(pageModuleId, userdata) {
    const { entities } = this.data;
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...entities.pageModules[pageModuleId],
            data: {
              ...entities.pageModules[pageModuleId].data,
              userdata
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  savePageModuleComplete(pageModuleId, content, params) {
    const { entities } = this.data;
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...entities.pageModules[pageModuleId],
            content,
            data: {
              ...entities.pageModules[pageModuleId].data,
              params
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  addPageModuleComplete(pageRows) {
    const toc = {
      id: this.data.result,
      pageRows
    };
    const data = normalize(toc, page);
    const { entities } = this.data;
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageRows: {
          ...entities.pageRows,
          ...data.entities.pageRows
        },
        pageModules: {
          ...entities.pageModules,
          ...data.entities.pageModules
        },
        page: {
          ...entities.page,
          [data.result]: {
            ...entities.page[data.result],
            pageRows: entities.page[data.result].pageRows.concat(
              data.entities.page[data.result].pageRows
            )
          }
        }
      }
    };
    this.trigger(this.data);
  },
  setPageModuleFile(pageRowId, moduleId, file){
    return SteelCompass.request('course', 'update', { id, ...data }).then(
      response => {
        CourseActions.updateComplete(id, data);
      },
      error => {
        AppActions.genericError(error);
      }
    );
    return SteelCompass.request('content', 'saveDataForObject', {
      objectId: moduleId,
      objectType: 'pageModule',
      data: file
    }).then(
      page => {
        this.setUserdata(pageRowId, moduleId, file);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  setUserdata(pageRowId, moduleId, file){
    const { entities } = this.data;
    const pageModule = entities.pageModules[moduleId];
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [moduleId]: {
            ...pageModule,
            data: {
              ...pageModule.data,
              userdata: file
            }
          }
        }
      }
    };
  },
  uploadComplete(pageModuleId, file) {
    const { entities } = this.data;
    const pageModule = entities.pageModules[pageModuleId];
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...pageModule,
            data: {
              ...pageModule.data,
              params: {
                ...pageModule.data.params,
                task: {
                  ...pageModule.data.params.task,
                  captionFiles: [file]
                }
              }
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  answerTaskComplete(taskId, pageModuleId, taskResult, bodyFiles) {
    const { entities } = this.data;
    taskResult.feedback = taskResult.feedback || {};
    // taskResult.body = {
    //   ...taskResult.body,
    // };
    taskResult.bodyFiles = bodyFiles;
    const pageModule = entities.pageModules[pageModuleId];
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...pageModule,
            data: {
              ...pageModule.data,
              params: {
                ...pageModule.data.params,
                taskResults: [
                  ...(pageModule.data.params.taskResults || []),
                  taskResult
                ]
              }
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  updateTaskComplete(pageModuleId, task) {
    const { entities } = this.data;
    const pageModule = entities.pageModules[pageModuleId];
    this.data = {
      ...this.data,
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          [pageModuleId]: {
            ...pageModule,
            data: {
              ...pageModule.data,
              params: {
                ...pageModule.data.params,
                task: {
                  ...pageModule.data.params.task,
                  ...task
                }
              }
            }
          }
        }
      }
    };
    this.trigger(this.data);
  },
  deletePageModuleComplete(pageModuleId) {
    const pageModules = {
      ...this.data.entities.pageModules
    };
    delete pageModules[pageModuleId];
    const pageRows = {
      ...this.data.entities.pageRows
    };

    Object.keys(pageRows).some(pageRowId => {
      const pageRow = pageRows[pageRowId];
      const pageModuleIndex = pageRow.pageModules.findIndex(
        pageModule => pageModule.id === pageModuleId
      );
      if (pageModuleIndex > -1) {
        pageRows[pageRowId] = {
          ...pageRows[pageRowId],
          pageModules: pageRows.pageModules.filter(_id => _id !== pageModuleId)
        };
        return true;
      }
    });

    this.data = {
      ...this.data,
      entities: {
        ...this.data.entities,
        pageRows,
        pageModules
      }
    };
    this.trigger(this.data);
  },
  enable() {
    this.data = {
      ...this.data,
      enabled: true
    };
    this.trigger(this.data);
  },
  disable() {
    this.data = {
      ...this.data,
      enabled: false
    };
    this.trigger(this.data);
  },
  toggle() {
    if (this.data.enabled) {
      this.disable();
    } else {
      this.enable();
    }
  },
  openModuleMenu() {
    this.data = {
      ...this.data,
      moduleMenuEnabled: true
    };
    this.trigger(this.data);
  },
  closeModuleMenu() {
    this.data = {
      ...this.data,
      moduleMenuEnabled: false
    };
    this.trigger(this.data);
  },
  toggleModuleMenu() {
    if (this.data.moduleMenuEnabled) {
      this.closeModuleMenu();
    } else {
      this.openModuleMenu();
    }
  },
  overRow(position, id) {
    const { overRow } = this.data;
    if (overRow.id !== id || overRow.position !== position) {
      const { entities } = this.data;
      let pageRows = {
        ...entities.pageRows
      };
      const { drag } = entities.pageModules;
      if (drag) {
        pageRows = {
          ...pageRows,
          [drag.pageRowId]: {
            ...pageRows[drag.pageRowId],
            pageModules: pageRows[drag.pageRowId].pageModules.filter(
              pageModuleId => pageModuleId !== 'drag'
            )
          }
        };
      }
      this.data = {
        ...this.data,
        entities: {
          ...entities,
          pageRows,
          pageModules: {
            ...entities.pageModules,
            drag: null
          }
        },
        overRow: {
          position,
          id
        }
      };
      this.trigger(this.data);
    }
  },
  resetDragging() {
    const { entities } = this.data;
    this.data = {
      ...this.data,
      overRow: {},
      entities: {
        ...entities,
        pageModules: {
          ...entities.pageModules,
          drag: null
        }
      }
    };
    this.trigger(this.data);
  },
  setDraggingPos(pageRowId, dropPosition, pageModuleId) {
    const { entities } = this.data;
    let { pageRows, pageModules } = entities;
    let { drag } = pageModules;
    if (
      drag &&
      drag.pageModuleId === pageModuleId &&
      drag.pageRowId === pageRowId &&
      drag.dropPosition === dropPosition
    ) {
      return;
    }
    if (drag && drag.pageRowId === pageRowId) {
      const dragIndex = pageRows[drag.pageRowId].pageModules.findIndex(
        _pageModuleId => _pageModuleId === 'drag'
      );
      if (dragIndex === dropPosition) {
        return;
      }
    }
    // Remove it from the old section
    if (drag) {
      Object.keys(pageRows).forEach(id => {
        const section = pageRows[id];
        if (section.pageModules.findIndex(_mid => _mid === 'drag') > -1) {
          pageRows[id] = {
            ...pageRows[id],
            pageModules: section.pageModules.filter(_mid => _mid !== 'drag')
          };
        }
      });
    }
    drag = {
      id: 'drag',
      pageRowId,
      dropPosition,
      pageModuleId,
      subType: pageModules[pageModuleId].type,
      type: 'Drag'
    };

    // create a new drag handle
    pageModules = {
      ...pageModules,
      drag
    };
    // Add it to the new section
    const newModules = pageRows[pageRowId].pageModules.filter(
      _pageModuleId => _pageModuleId !== 'drag'
    );
    newModules.splice(dropPosition, 0, 'drag');
    pageRows = {
      ...pageRows,
      [pageRowId]: {
        ...pageRows[pageRowId],
        pageModules: newModules
      }
    };
    this.data = {
      ...this.data,
      entities: {
        ...this.data.entities,
        pageRows,
        pageModules
      },
      overRow: {}
    };
    this.trigger(this.data);
  },
  endDragging(pageRowId, item) {
    const { entities, overRow } = this.data;
    const { drag } = entities.pageModules;
    if (!drag && overRow && overRow.id) {
      return this.moveToNewRow(overRow.id, pageRowId, item.pageModuleId);
    }
    let { pageRows, pageModules } = entities;
    if (drag) {
      const { pageRowId: toPageRowId, pageModuleId } = drag;
      pageModules = {
        ...pageModules,
        drag: null
      };
      this.data = {
        ...this.data,
        overRow: {},
        entities: {
          ...entities,
          pageModules
        }
      };
      // this.saveSnapshot();

      if (pageRowId === toPageRowId) {
        const section = {
          ...pageRows[pageRowId],
          pageModules: pageRows[pageRowId].pageModules
            .filter(_mId => _mId !== pageModuleId)
            .map(id => {
              if (id === 'drag') {
                return pageModuleId;
              }
              return id;
            })
        };
        pageRows = {
          ...pageRows,
          [pageRowId]: section
        };
        pageRows[pageRowId].pageModules.forEach((id, index) => {
          CourseActions.updatePageModule(id, { sortOrder: index + 1 });
        });
      } else {
        const section = {
          ...pageRows[pageRowId],
          pageModules: pageRows[pageRowId].pageModules.filter(
            _mId => _mId !== pageModuleId
          )
        };
        const toSection = {
          ...pageRows[toPageRowId],
          pageModules: pageRows[toPageRowId].pageModules.map(id => {
            if (id === 'drag') {
              return pageModuleId;
            }
            return id;
          })
        };
        pageRows = {
          ...pageRows,
          [pageRowId]: section,
          [toPageRowId]: toSection
        };
        pageRows[toPageRowId].pageModules.forEach((id, index) => {
          CourseActions.updatePageModule(id, {
            pageRowId: toPageRowId,
            sortOrder: index + 1
          });
        });
      }
      this.data = {
        ...this.data,
        entities: {
          ...entities,
          pageRows
        }
      };
      if (pageRows[pageRowId].pageModules.length < 1) {
        this.data.entities.page[
          this.data.result
        ].pageRows = this.data.entities.page[this.data.result].pageRows.filter(
          id => id !== pageRowId
        );
        delete pageRows[pageRowId];
      }
      this.trigger(this.data);
    }
  },
  moveToNewRow(toPageRowId, fromPageRowId, pageModuleId) {
    const { entities, overRow } = this.data;
    const pageRows = [...entities.page[this.data.result].pageRows];
    const offset = overRow.position === 'after' ? 1 : 0;
    const dropRowIndex = pageRows.findIndex(
      _pageRowId => overRow.id === _pageRowId
    );
    SteelCompass.request('page-module', 'moveToNewPageRow', {
      id: pageModuleId,
      pageRowPosition: Math.max(1, dropRowIndex + 1 + offset)
    }).then(
      insertedPageRow => {
        const pageRow = {
          id: insertedPageRow.id,
          pageModules: insertedPageRow.pageModules.map(
            pageModule => pageModule.id
          )
        };
        if (entities.pageRows[fromPageRowId].pageModules.length === 1) {
          this.moveRow(fromPageRowId, toPageRowId, offset);
          return;
        }
        pageRows.splice(dropRowIndex + offset, 0, pageRow.id);
        this.data = {
          ...this.data,
          overRow: {}
        };
        // this.saveSnapshot();
        this.data = {
          ...this.data,
          entities: {
            ...entities,
            pageRows: {
              ...entities.pageRows,
              [fromPageRowId]: {
                ...entities.pageRows[fromPageRowId],
                pageModules: entities.pageRows[
                  fromPageRowId
                ].pageModules.filter(id => id !== pageModuleId)
              },
              [pageRow.id]: pageRow
            },
            page: {
              ...entities.page,
              [this.data.result]: {
                ...entities.page[this.data.result],
                pageRows
              }
            }
          },
          overRow: {}
        };
        if (this.data.entities.pageRows[fromPageRowId].pageModules.length < 1) {
          delete this.data.entities.pageRows[fromPageRowId];
          this.data.entities.page[
            this.data.result
          ].pageRows = this.data.entities.page[
            this.data.result
          ].pageRows.filter(id => id !== fromPageRowId);
        }
        this.trigger(this.data);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },

  moveRow(fromPageRowId, toPageRowId, offset) {
    this.data = {
      ...this.data,
      overRow: {}
    };
    // this.saveSnapshot();
    const currentPage = this.data.entities.page[this.data.result];
    const { pageRows } = currentPage;
    const index = pageRows.findIndex(id => fromPageRowId === id);
    const destIndex = pageRows.findIndex(id => toPageRowId === id);
    if (index > -1) {
      this.data = {
        ...this.data,
        entities: {
          ...this.data.entities,
          page: {
            ...this.data.entities.page,
            [this.data.result]: {
              ...currentPage,
              pageRows: moveElement(
                pageRows,
                index,
                Math.max(destIndex + offset, 0)
              )
            }
          }
        }
      };
      this.trigger(this.data);
    }
  }
});

export default PageLayoutStore;



// WEBPACK FOOTER //
// ./src/js/stores/PageLayout.js